import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const updatedAtFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("updated_at_filter"),
  comparison_key: z.enum(["3", "4", "6", "5"]),
  display_name: z.string(),
  raw_value: z.union([z.number().nonnegative(), common.date]).optional(),
  value: z.union([z.number().nonnegative(), common.date]),
  varies_by_app_group: z.literal(false),
});
